import styled from '@emotion/styled';
import KizenTypography from 'app/kizentypo';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-basis: 50%;
  &:last-of-type > hr {
    display: none;
  }
`;

const Divider = styled.hr`
  width: 80%;
  margin: 30px auto;
  border: none;
  height: 1px;
  background-color: var(--color-background-medium);
`;

const Content = styled.div`
  flex-direction: column;
  width: 100%;
  & .row {
    margin-right: -10px;
    margin-left: -10px;
  }
  & .col {
    padding-left: 10px;
    padding-right: 10px;
  }
`;
const Header = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-content: flex-start;
  & > p {
    margin-bottom: 26px;
  }
  & > button {
    margin-top: -5px;
  }
`;

const SubSection = ({ title = null, children, ...others }) => {
  return (
    <Wrapper {...others}>
      {title && (
        <KizenTypography type="subheader" margin="md">
          {title}
        </KizenTypography>
      )}
      {children}
      <Divider />
    </Wrapper>
  );
};

const SubSectionWithHeader = ({
  title = null,
  action = null,
  children,
  ...others
}) => {
  return (
    <Wrapper {...others}>
      <Content>
        <Header>
          {title && (
            <KizenTypography type="subheader" margin="md">
              {title}
            </KizenTypography>
          )}
          {action}
        </Header>

        {children}
      </Content>
    </Wrapper>
  );
};

export default SubSection;
export { SubSectionWithHeader };
